import { MagnifyMinusIcon } from './MagnifyMinusIcon';

/**
 * author: Austin Andrews
 * id 36D3966F-BFA2-407B-BF36-D21FBA930930
 * name magnify-minus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify-minus.svg
 * tags
 */
export const ZoomOutIcon = MagnifyMinusIcon;
export default ZoomOutIcon